var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "",
        visible: _vm.visible,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        "append-to-body": "",
        width: "400px"
      }
    },
    [
      _c("div", [
        _c("p", { staticClass: "tips" }, [
          _vm._v(_vm._s(_vm.$t("message.frequentlyTips")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "code-img" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "img-box"
            },
            [
              _vm.codeUrl
                ? _c("img", {
                    attrs: { src: _vm.codeUrl, alt: "" },
                    on: { click: _vm.getCheckCode, error: _vm.imgError }
                  })
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("span", { on: { click: _vm.getCheckCode } }, [
            _vm._v(_vm._s(_vm.$t("btn.refresh")))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "handler" },
          [
            _c("el-input", {
              attrs: { type: "text", placeholder: "", maxlength: "6" },
              model: {
                value: _vm.checkCode,
                callback: function($$v) {
                  _vm.checkCode = $$v
                },
                expression: "checkCode"
              }
            }),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.submit } },
              [_vm._v(_vm._s(_vm.$t("btn.confirm")))]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-645a74e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-645a74e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/checkCode/index.vue
// module id = null
// module chunks = 